import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@rtkwlf/pro-solid-svg-icons/faClose';
import { useTranslation } from 'react-i18next';

import { useActionDrawer } from '@packages/components/action-drawer/action-drawer-context';
import {
  Typography,
  Button,
  Box,
  List,
  ListItem,
  Stack,
  LinkRouter,
  Tooltip,
} from '@packages/fenrir/components';

import type { ListWithDrawerProps } from './list-with-drawer';

type Props = Omit<ListWithDrawerProps, 'maxVisible'>;

export const ListMore = ({ title, list, type }: Props) => {
  const { t } = useTranslation('ui');
  const { closeDrawer } = useActionDrawer();

  return (
    <Box sx={{ p: 4 }}>
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: 'center',
          mb: 4,
          px: 2,
          justifyContent: 'space-between',
        }}
      >
        <Stack>
          <Typography variant="h4">{title}</Typography>
        </Stack>
        <Button
          startIcon={<FontAwesomeIcon icon={faClose} aria-label={t('close')} />}
          onClick={closeDrawer}
          variant="outlined"
        >
          {t('close')}
        </Button>
      </Stack>
      <List disablePadding>
        {list.map((item, idx) => (
          <React.Fragment key={item}>
            <ListItem>
              {type === 'link' ? (
                <Tooltip title={item} placement="top">
                  <LinkRouter variant="body2" to={item} isExternal noWrap>
                    {item}
                  </LinkRouter>
                </Tooltip>
              ) : (
                <Typography variant="body2" sx={{ overflowWrap: 'break-word' }}>
                  {item}
                </Typography>
              )}
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};
